"use client";

import * as React from "react";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
function DigitalShopPromotionConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="container mx-auto px-4">
        <div className="flex gap-6 overflow-hidden">
          {[...Array(5)].map((_, i) => <div key={i} data-index={i} className="h-96 w-64 flex-shrink-0 rounded-[var(--radius-md)] bg-muted/30 animate-pulse" />)}
        </div>
      </div>;
  }
  if (error) {
    return <div className="container mx-auto px-4 text-center">
        <p className="text-dark-foreground/70">Failed to load products.</p>
      </div>;
  }
  if (products.length === 0) {
    return <div className="container mx-auto px-4 text-center">
        <p className="text-dark-foreground/70">No digital guides available at the moment.</p>
      </div>;
  }
  return <div className="container mx-auto px-4">
      <Carousel opts={{
      align: "start",
      loop: false
    }} className="w-full">
        <CarouselContent className="-ml-4">
          {products.map((product, i) => <CarouselItem key={product.id} data-index={i} className="basis-full sm:basis-1/2 md:basis-1/3 lg:basis-1/4 xl:basis-1/5 pl-4">
              <div className="group relative overflow-hidden rounded-[var(--radius-md)] bg-white shadow-soft transition-all duration-medium ease-smooth hover:shadow-medium hover:-translate-y-1">
                <Link to={product.link}>
                  <div className="relative aspect-[3/4] overflow-hidden bg-muted">
                    {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-medium group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted">
                        <span className="text-sm text-muted-foreground">No Image</span>
                      </div>}
                    
                    {product.price !== undefined && <div className="absolute top-3 right-3">
                        <Badge className="bg-accent text-foreground-accent font-semibold shadow-medium group-hover:bg-accent-hover transition-colors duration-fast">
                          ${product.price.toFixed(2)}
                        </Badge>
                      </div>}
                  </div>

                  <div className="p-4">
                    <h3 className="text-base font-semibold text-foreground line-clamp-2 mb-2 leading-tight">
                      {product.title}
                    </h3>
                    
                    {product.short_description && <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
                        {product.short_description}
                      </p>}
                  </div>
                </Link>

                <div className="px-4 pb-4">
                  <AddToCartButton productId={product.id} variant="default" size="sm" className="w-full" buttonClassName="bg-primary text-foreground-primary" text="Add to Cart" showQuantity={false} />
                </div>
              </div>
            </CarouselItem>)}
        </CarouselContent>
        
        <CarouselPrevious className="-left-4 md:-left-12" />
        <CarouselNext className="-right-4 md:-right-12" />
      </Carousel>

      <div className="mt-8 h-1 bg-muted/30 rounded-full overflow-hidden">
        <div className="h-full bg-accent transition-all duration-300 ease-smooth" style={{
        width: `${100 / products.length * Math.min(5, products.length)}%`
      }} />
      </div>
    </div>;
}
export default function DigitalShopPromotion() {
  return <section id="digital-shop-promotion" className="dark bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 mb-12">
        <h2 className="text-3xl md:text-4xl font-display font-semibold text-center mb-4">
          Budget Survival Guides
        </h2>
        <p className="text-center text-dark-foreground/80 max-w-2xl mx-auto">
          Download our expert PDF guides and unlock insider tips for traveling France on a budget
        </p>
      </div>

      <EcommerceProductsProvider postType="product" wp_query={{
      per_page: 6,
      order: "desc",
      orderby: "date",
      product_cat: [17]
    }} fields={["id", "title.rendered", "short_description", "price", "discounted_price", "featured_image_url", "link", "categories", "meta"]}>
        <DigitalShopPromotionConsumer />
      </EcommerceProductsProvider>
    </section>;
}